import React, {memo} from "react";

export const IconQuoteClose = memo(({color, addClass}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 13C5.424 13 6.283 12.72 6.999 12.241C5.702 14.486 3.274 16 0.5 16C0.224 16 0 16.224 0 16.5C0 16.776 0.224 17 0.5 17C2.77 17 4.905 16.116 6.51 14.51C8.115 12.904 9 10.77 9 8.5C9 6.019 6.981 4 4.5 4C2.019 4 0 6.019 0 8.5C0 10.981 2.019 13 4.5 13ZM4.5 5C6.43 5 8 6.57 8 8.5C8 8.53 7.999 8.56 7.999 8.59C7.951 10.478 6.4 12 4.5 12C2.57 12 1 10.43 1 8.5C1 6.57 2.57 5 4.5 5Z"
        fill={color || "#6BC069"}
      />
      <path
        d="M11.5 16C11.224 16 11 16.224 11 16.5C11 16.776 11.224 17 11.5 17C13.77 17 15.905 16.116 17.51 14.51C19.115 12.904 20 10.77 20 8.5C20 6.019 17.981 4 15.5 4C13.019 4 11 6.019 11 8.5C11 10.981 13.019 13 15.5 13C16.424 13 17.283 12.72 17.999 12.241C16.702 14.486 14.274 16 11.5 16ZM15.5 12C13.57 12 12 10.43 12 8.5C12 6.57 13.57 5 15.5 5C17.43 5 19 6.57 19 8.5C19 8.53 18.999 8.56 18.999 8.59C18.951 10.478 17.4 12 15.5 12Z"
        fill={color || "#6BC069"}
      />
    </svg>
  );
});
